module.exports = __webpack_public_path__ + "img/spotted-orange-lily.fd4ef6c2.webp";